import { render } from "./SpendPlanManagement.vue?vue&type=template&id=2f716dc3"
import script from "./SpendPlanManagement.vue?vue&type=script&lang=js"
export * from "./SpendPlanManagement.vue?vue&type=script&lang=js"

import "./SpendPlanManagement.vue?vue&type=style&index=0&id=2f716dc3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__